module.exports = __webpack_public_path__ + "bariol_regular-webfont.asset.32397546770998c6da37c310f91c6801.woff";